import { IMRBaseComponent } from "../../base"
import { IMRSelectGridController } from "./select-grid.controller"

//#region Assets Imports

import './select-grid.scss'
import * as TEMPLATE from './select-grid.tpl.html'

//#endregion

export const COMPONENT_NAME: string = 'imrSelectGrid'

export class IMRSelectGridComponent extends IMRBaseComponent {

    //#region Ctor

    public constructor() {
        super({
            controller: IMRSelectGridController,
            template: TEMPLATE
        })
    }

    //#endregion
}
